/**
 * Frontend feature flags — flip these to true to re-enable temporarily disabled features.
 *
 * IMPORTANT: this is a build-time flag (no dynamic re-fetch). To re-enable a feature:
 *   1. Change the value below from `false` to `true`
 *   2. Restart the frontend (`sudo supervisorctl restart frontend`) — hot-reload also picks it up
 *
 * Kept as a single source of truth so we don't have to hunt across the codebase.
 */
export const FEATURES = {
  // 3D Galaxy Explorer — /explorer route, Header link, About card
  explorer: false,

  // Paid tournament rooms (real-money USDT entry fee) — tab in /rooms
  // When false: only ticket rooms + special tournaments show up.
  paidRooms: false,

  // Full tournament rooms page (/rooms). Disables entry buttons, landing-page banners
  // (RoomStartBanner, TicketExpiringBanner), and the PilotGame "TOURNAMENT ROOMS" CTA.
  // Turn back ON when the finance rework is done.
  rooms: false,
};
